import React from "react";
import styles from "./style.module.css";
import { images } from "../../../../assets/images";

const JoinCommunity = () => {
  const { Iphone, GreenDot } = images;
  const data = [
    {
      text: "Onboard and Interact the audiences.",
      color: "rgba(49, 90, 211, 0.1)",
    },
    {
      text: "Post your queries and get it resolved.",
      color: "rgba(241, 146, 35, 0.1)",
    },
    {
      text: "Join the events and discussions.",
      color: "rgba(21, 20, 73, 0.1)",
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.headingContainer}>
        <img alt="Iphone" src={GreenDot} className={styles.icon} />
        <span className={styles.heading}>Join the Community</span>
      </div>
      <div className={styles.cardContainer}>
        {data.map((item, index) => (
          <div
            key={index}
            className={styles.card}
            style={{ backgroundColor: item.color }}
          >
            <p className={styles.text}>{item.text}</p>
            <img src={Iphone} alt="Iphone" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default JoinCommunity;
